import Flickity from "flickity";

const initAboutImageSlider = (sections) => {
    sections.forEach((section) => {
        const slider = section.querySelector('.js-slider');
        if (!slider) return;
        const nextButton = section.querySelector('.js-slider-next');

        const flkty = new Flickity(slider, {
            cellSelector: '.js-cell',
            prevNextButtons: false,
            wrapAround: true,
            cellAlign: 'center',
            pageDots: false,
            autoplay: false
        });

        nextButton.addEventListener('click', () => {
            flkty.next();
        });
    });
};

export default initAboutImageSlider;
